/*
 * DISTRIBUTION STATEMENT C. Distribution authorized to U.S. Government Agencies and their contractors; Critical
 * Technology; 19 October 2017. Other requests for this document shall be referred to Chemical and Biological
 * Technologies, Defense Threat Reduction Agency, 8725 John J Kingman Road, Fort Belvoir, VA 22060-6201.
 *
 * WARNING: This document contains technical data whose export is restricted by the Arms Export Control Act (Sec 2751
 * of Title 22, United States Code) or the Export Control Reform Act of 2018 (Chapter 58 Sections 4801-4852 of Title
 * 50, United States Code). Violations of these export laws are subject to severe criminal penalties. Disseminate in
 * accordance with provisions of DoD Directive 5230.25 and DoD Instruction 2040.02. DESTRUCTION NOTICE: For
 * unclassified, limited distribution documents, destroy by any method that will prevent disclosure of the contents
 * or reconstruction of the document.
 *
 * This material is based upon work supported by the Under Secretary of War for Research and Engineering under Air
 * Force Contract No. FA8702-15-D-0001 or FA8702-25-D-B002. Any opinions, findings, conclusions or recommendations
 * expressed in this material are those of the author(s) and do not necessarily reflect the views of the Under
 * Secretary of War for Research and Engineering.
 *
 * © 2026 Massachusetts Institute of Technology.
 *
 * The software/firmware is provided to you on an As-Is basis
 *
 * Delivered to the U.S. Government with Unlimited Rights, as defined in DFARS Part 252.227-7013 or 7014 (Feb 2014).
 * Notwithstanding any copyright notice, U.S. Government rights in this work are defined by DFARS 252.227-7013 or
 * DFARS 252.227-7014 as detailed above. Use of this work other than as specifically authorized by the U.S.
 * Government may violate any copyrights that exist in this work.
 *
 * This document contains Controlled Unclassified Information (CUI). Handling of this information is subject to the
 * controls identified in DFARS 252.204-7012 - SAFEGUARDING COVERED DEFENSE INFORMATION AND CYBER INCIDENT REPORTING.
 */

import { combineReducers } from 'redux';
import {
  SET_USER_INFO,
  SET_USER_LOADING,
  SET_BUILD_INFO,
  SET_DAL_OPTIONS,
  SET_STUDY_STATUS_OPTIONS,
  SET_ORGANISM_OPTIONS,
  SET_ORGANIZATIONS_OPTIONS,
  SET_SPONSORS_OPTIONS,
  SET_DATA_TYPE_OPTIONS,
  SET_EXPOSURE_TYPE_OPTIONS,
  SET_TRUTH_DATA_OPTIONS,
  SET_STUDY_SEARCH_QUERY,
  SET_STUDY_SEARCH_RESULTS,
  SET_TAGS,
  SET_SUPPORT_FLAGS,
  SET_MODEL_TYPES_OPTIONS,
  SET_MODEL_EXPOSURE_TYPES_OPTIONS,
  SET_PAGE_INFO,
  SET_TOOLS_PAGE,
  SET_FEATURE_COHORT,
  SET_FEATURE_STUDYCARD,
  SET_FEATURE_ANALYST_WORKBENCH,
  SET_PAGE_LOADING,
  SET_THEME,
  SET_KUBEFLOW_PROVISIONING
} from './actions';

function userInfo(state = {}, action) {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        ...action.userInfo
      }
    default: 
      return state;
  }
}

function userLoading(state = {}, action) {
  switch (action.type) {
    case SET_USER_LOADING:
      return action.userLoading;
    default: 
      return state;
  }
}


function studyRegistrationOptions(state = {}, action) {
  switch (action.type) {
    case SET_DAL_OPTIONS:
      return {
        ...state,
        dal_options: action.options
      }
    case SET_STUDY_STATUS_OPTIONS:
      return {
        ...state,
        study_status_options: action.options
      }
    case SET_ORGANISM_OPTIONS:
      return {
        ...state,
        organism_options: action.options
      }
    case SET_ORGANIZATIONS_OPTIONS:
      return {
        ...state,
        collab_org: action.options
      }
    case SET_SPONSORS_OPTIONS:
      return {
        ...state,
        sponsor_options: action.options
      }
    case SET_DATA_TYPE_OPTIONS:
      return {
        ...state,
        data_type: action.options
      }
    case SET_EXPOSURE_TYPE_OPTIONS:
      return {
        ...state,
        exposure_type: action.options
      }
    case SET_TRUTH_DATA_OPTIONS:
      return {
        ...state,
        truth_data: action.options
      }
    case SET_TAGS:
      return {
        ...state,
        tags: action.tags
      }
    default: 
      return state;
  }
}

function algorithmRegistrationOptions(state = {}, action) {
  switch (action.type) {
    case SET_MODEL_TYPES_OPTIONS:
      return {
        ...state,
        model_types: action.options
      }
    case SET_MODEL_EXPOSURE_TYPES_OPTIONS:
      return {
        ...state,
        model_exposure_types: action.options
      }
    default: 
      return state;
  }
}

// function toolRegistrationOptions(state = {}, action) {
//   switch (action.type) {
//     default:
//       return state;
//   }
// }

function studySearch(state = {}, action) {
  switch (action.type) {
    case SET_STUDY_SEARCH_QUERY:
      return {
        ...state,
        query: action.query
      }
    case SET_STUDY_SEARCH_RESULTS:
      return {
        ...state,
        result: action.results
      }
    default: 
      return state;
  }
}

function tags(state = {}, action) {
  switch (action.type) {
    case SET_TAGS:
      return action.tags;
    default: 
      return state;
  }
}

function supportFlags(state = {}, action) {
  switch (action.type) {
    case SET_SUPPORT_FLAGS:
      return action.supportFlags;
    default:
      return state;
  }
}

function buildInfo(state = '', action) {
  switch (action.type) {
    case SET_BUILD_INFO:
      return action.buildInfo;
    default:
      return state;
  }
}

function pageInfo(state ='', action){
  switch (action.type) {
    case SET_PAGE_INFO:
      return {
        ...state,
        ...action.pages
      }
    case SET_TOOLS_PAGE:
      return {
        ...state,
        tools_page: action.toolsPage
      }
    case SET_FEATURE_COHORT:
      return {
        ...state,
        feature_cohort: action.feature_cohort
      }
    case SET_FEATURE_STUDYCARD:
      return {
        ...state,
        feature_studycard_v2: action.feature_studycard_v2
      }
    case SET_FEATURE_ANALYST_WORKBENCH:
      return {
        ...state,
        feature_analyst_workbench: action.feature_aw
      }
    case SET_PAGE_LOADING:
      return {
        ...state,
        page_loading: action.pageLoading
      }
    default:
      return state;
  }
}

function theme(state ='', action){
  switch (action.type) {
    case SET_THEME:
      return {
        ...state,
        theme: action.theme
      }
    default:
      return state;
  }
}

function kubeflowProvisioning(state = false, action) {
  switch (action.type) {
    case SET_KUBEFLOW_PROVISIONING:
      return action.kubeflowProvisioning;
    default:
      return state;
  }
}


const combinedReducers = combineReducers({
  userInfo,
  userLoading,
  studyRegistrationOptions,
  algorithmRegistrationOptions,
  studySearch,
  tags,
  supportFlags,
  buildInfo,
  pageInfo,
  theme,
  kubeflowProvisioning,
});

export default combinedReducers;